/**
 * useSessionSync returns the current Amplify auth session.
 * Amplify manages token storage in cookies (configured in App.tsx via CookieStorage).
 */
import { fetchAuthSession } from 'aws-amplify/auth';
import { useEffect, useState } from 'react';

export const useSessionSync = () => {
  const [session, setSession] = useState<any>(null);

  useEffect(() => {
    const getSession = async () => {
      try {
        const authSession = await fetchAuthSession();
        setSession(authSession);
      } catch (error) {
        console.error('Error fetching auth session:', error);
      }
    };
    getSession();
  }, []);

  return session;
};
